// Resend cooldown timer — replaces the setInterval countdowns in auth.js
// (_startResendCountdown / _doResend). start(seconds) begins the countdown;
// `remaining` drives the UI, `active` is true while counting down.

import { useEffect, useRef, useState } from 'react'

export function useCountdown() {
  const [remaining, setRemaining] = useState(0)
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)

  const stop = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }

  const start = (seconds: number) => {
    stop()
    setRemaining(seconds)
    intervalRef.current = setInterval(() => {
      setRemaining((r) => {
        if (r <= 1) {
          stop()
          return 0
        }
        return r - 1
      })
    }, 1000)
  }

  useEffect(() => stop, [])

  return { remaining, active: remaining > 0, start, stop }
}
